import { assetQuery, sanityFetch } from './sanity';
import shopifyBuy from 'shopify-buy/index.unoptimized.umd';
export var ShopifyProductType;
(function (ShopifyProductType) {
    ShopifyProductType["Apparel"] = "apparel";
    ShopifyProductType["Patches"] = "patches";
    ShopifyProductType["Prints"] = "prints";
    ShopifyProductType["Special"] = "special";
    ShopifyProductType["Stickers"] = "stickers";
})(ShopifyProductType || (ShopifyProductType = {}));
const shopQuery = `{
  _id,
  bannerText,
  carouselItems[] {
    _key,
    image ${assetQuery},
    productSlug,
    title
  }
}`;
export const configureShopifyClient = (config) => {
    return shopifyBuy.buildClient({
        domain: `${config.SHOPIFY_ID}.myshopify.com`,
        storefrontAccessToken: config.SHOPIFY_STOREFRONT_ACCESS_TOKEN
    });
};
export const getShopIndexConfig = async (config) => {
    return sanityFetch(config, `*[
    _type == 'shop'
    && _id == 'singleton-shop'
  ][0]${shopQuery}`);
};
export const getShopifyProducts = async (shopifyClient) => {
    const productsQuery = shopifyClient.graphQLClient.query((root) => {
        root.addConnection('products', { args: { first: 250 } }, (product) => {
            product.add('tags');
        });
    });
    const response = await shopifyClient.graphQLClient.send(productsQuery);
    const edges = response.data.products?.edges || [];
    const products = await shopifyClient.product.fetchAll(250);
    (products || []).forEach((product, index) => {
        const tagProduct = edges.find((edge) => {
            return edge.node.id === product.id;
        });
        if (tagProduct) {
            products[index].tags = tagProduct.node.tags || [];
        }
    });
    return products;
};
export const getShopifyProduct = async (shopifyClient, productId) => {
    const id = productId.split('/')[productId.split('/').length - 1];
    const productsQuery = shopifyClient.graphQLClient.query((root) => {
        root.addConnection('products', { args: { first: 1, query: `id:${id}` } }, (product) => {
            product.add('tags');
        });
    });
    const { data: { products: { edges } } } = await shopifyClient.graphQLClient.send(productsQuery);
    const product = await shopifyClient.product.fetch(productId);
    const tagProduct = (edges || []).find((edge) => {
        return edge.node.id === product.id;
    });
    if (tagProduct) {
        product.tags = tagProduct.node.tags || [];
    }
    return product;
};
export const getShopifyStoreCollection = async (config, shopifyClient) => {
    return shopifyClient.collection.fetchWithProducts(Buffer.from(`gid://shopify/Collection/${config.SHOPIFY_PRIMARY_COLLECTION}`).toString('base64'), { productsFirst: 250 });
};
export const deriveProductBasePrice = (product) => {
    let minVariantPrice = 0;
    (product?.variants || []).forEach((variant) => {
        const price = parseFloat(variant.price.amount);
        if (price > minVariantPrice) {
            minVariantPrice = price;
        }
    });
    return minVariantPrice;
};
//# sourceMappingURL=shopify.js.map